import styled from '@emotion/styled'
import { Flex } from '@collable/ui'
import Header from '../common/Header'
import MyChannelsSidebar from './Sidebar'
import { useManagePageQueryParams } from '@/hooks/queryParams/useManagePageQueryParams'
import VerifyStatus from './VerifyStatus'
import { isVerified } from '@/utils/verify'

interface ManagePageLayoutProps {
  children: React.ReactNode
  pageType: 'video' | 'channel'
}

const ManagePageLayout = ({ children, pageType }: ManagePageLayoutProps) => {
  const { selectedChannel } = useManagePageQueryParams()
  const status = selectedChannel?.status ?? 'REQUESTED'
  return (
    <Container direction="column">
      <Header selectedMenu={pageType === 'video' ? 'videos' : 'channels'} />
      <Content alignItems="flex-start">
        <MyChannelsSidebar page={pageType} />
        {isVerified(status) ? children : <VerifyStatus status={status} />}
      </Content>
    </Container>
  )
}

export default ManagePageLayout

const Container = styled(Flex)`
  min-width: 100vh;
  min-height: 100vh;
`

const Content = styled(Flex)`
  flex: 1 1 0;
  overflow: hidden;
`
